export default __webpack_public_path__ + "static/media/img7.70885f4a.jpg";